import React from 'react';
import styled from 'styled-components';

const RowContainer = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${(props) => (props.height ? props.height : '50px')};
  color: ${(props) => (props.color ? 'white' : 'inherit')};
  background-color: ${(props) =>
    props.dark ? 'rgba(234,235,235,0.4)' : 'rgba(234,235,235,0.09)'};

  @media (max-width: 845px) {
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  }
  padding: ${(props) => (props.padding ? props.padding : '0')};
`;

const Row = ({ dark, disabled, children, height, padding, color }) => (
  <RowContainer
    height={height}
    padding={padding}
    dark={dark}
    disabled={disabled}
    color={color}
  >
    {children}
  </RowContainer>
);

export default Row;
